import { useTranslation } from 'react-i18next';
import { ProductMarketRestrictions, UnavailableProduct } from '@types';
import './style.scss';

type ProductErrorSectionProps = {
  isUpdateError?: boolean;
  restrictionReason?: UnavailableProduct['reason'];
};

export const ProductErrorSection = ({
  isUpdateError,
  restrictionReason,
}: ProductErrorSectionProps) => {
  const { t } = useTranslation();

  const isShippingReason = restrictionReason?.code.includes(
    ProductMarketRestrictions.SHIPPING_RESTRICTED_COUNTRIES,
  );

  const isBillingReason = restrictionReason?.code.includes(
    ProductMarketRestrictions.BILLING_RESTRICTED_COUNTRIES,
  );

  return (
    <div className="product-error-section">
      {isBillingReason && (
        <p className="product-error-section__item">
          {t('cart.productList.billingErrorRestrictedCountryProduct')}
        </p>
      )}
      {isShippingReason && (
        <p className="product-error-section__item">
          {t('cart.productList.shippingErrorRestrictedCountryProduct')}
        </p>
      )}
      {isUpdateError && t('cart.common.error')}
    </div>
  );
};
